import { useTranslation } from "react-i18next";
import { ChangeOrgTextField } from "./ChangeOrgTextField";

interface Props {
  currentValue: string;
}

export const ChangePostCode = ({ currentValue }: Props) => {
  const { t } = useTranslation();

  return (
    <ChangeOrgTextField
      currentValue={currentValue}
      fieldName="postCode"
      label={t("Post code")}
      helperText={t("Please provide your company's postal code")}
      toastMessage={t("Post code has been updated!")}
      buildPatch={(value) => ({ postCode: { value } })}
    />
  );
};
